import { render, staticRenderFns } from "./absences_table.vue?vue&type=template&id=70395443&scoped=true&lang=pug&"
import script from "./absences_table.vue?vue&type=script&lang=coffee&"
export * from "./absences_table.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70395443",
  null
  
)

export default component.exports